import { DfActionBarComponent } from './action-bar/df-action-bar.component';
import { DfAskStepComponent } from './ask-step/df-ask-step.component';
import { DfCoverageRailComponent } from './coverage-rail/df-coverage-rail.component';
import { DfDeckStepComponent } from './deck-step/df-deck-step.component';
import { DfDocDrawerComponent } from './doc-drawer/df-doc-drawer.component';
import { DfDocRowComponent } from './doc-row/df-doc-row.component';
import { DfExcludeModalComponent } from './exclude-modal/df-exclude-modal.component';
import { DfFeedbackStepComponent } from './feedback-step/df-feedback-step.component';
import { DfFileBadgeComponent } from './file-badge/df-file-badge.component';
import { DfIconComponent } from './icon/df-icon.component';
import { DfInfoPagesComponent } from './info-pages/df-info-pages.component';
import { DfMissingModalComponent } from './missing-modal/df-missing-modal.component';
import { DfPblStepComponent } from './pbl-step/df-pbl-step.component';
import { DfPublishStepComponent } from './publish-step/df-publish-step.component';
import { DfRetrieveStepComponent } from './retrieve-step/df-retrieve-step.component';
import { DfReviewStepComponent } from './review-step/df-review-step.component';
import { DfScopeChipsComponent } from './scope-chips/df-scope-chips.component';
import { DfSidebarComponent } from './sidebar/df-sidebar.component';
import { DfStepperComponent } from './stepper/df-stepper.component';

export {
    DfActionBarComponent, DfAskStepComponent, DfCoverageRailComponent, DfDeckStepComponent, DfDocDrawerComponent, DfDocRowComponent,
    DfExcludeModalComponent, DfFeedbackStepComponent, DfFileBadgeComponent, DfIconComponent, DfInfoPagesComponent,
    DfMissingModalComponent, DfPblStepComponent, DfPublishStepComponent, DfRetrieveStepComponent, DfReviewStepComponent,
    DfScopeChipsComponent, DfSidebarComponent, DfStepperComponent
};

/** Every component used by the SAP Explore Document Finder page. */
export const DOCUMENT_FINDER_COMPONENTS = [
    DfActionBarComponent,
    DfAskStepComponent,
    DfCoverageRailComponent,
    DfDeckStepComponent,
    DfDocDrawerComponent,
    DfDocRowComponent,
    DfExcludeModalComponent,
    DfFeedbackStepComponent,
    DfFileBadgeComponent,
    DfIconComponent,
    DfInfoPagesComponent,
    DfMissingModalComponent,
    DfPblStepComponent,
    DfPublishStepComponent,
    DfRetrieveStepComponent,
    DfReviewStepComponent,
    DfScopeChipsComponent,
    DfSidebarComponent,
    DfStepperComponent
];
